import { makeStyles } from 'tss-react/mui';

const name = 'CodeSnippetPlaceholder';

export const useCodeSnippetPlaceholderStyles = makeStyles({ name })(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',

    padding: theme.spacing(7.5, 2.5),
    margin: theme.spacing(10, 25),

    border: `1px solid ${theme.palette.divider}`,
    borderRadius: theme.shape.borderRadius,

    [theme.breakpoints.down('xs')]: {
      margin: 0,
    },
  },
  icon: {
    color: theme.palette.text.secondary,
  },
}));
